import React, { useState } from 'react';
import api from './services/api';

function Login({ onLoginSuccess }) {
    const [kullaniciAdi, setKullaniciAdi] = useState('');
    const [sifre, setSifre] = useState('');
    const [hata, setHata] = useState('');

    const handleLogin = async (e) => {
    e.preventDefault();
    setHata('');

    // Artık bu satıra ihtiyacımız yok, silebiliriz.
    // console.log('API URL:', process.env.REACT_APP_API_URL);

    try {
        // api.js'deki güncellenmiş login fonksiyonunu çağırıyoruz.
        const data = await api.login(kullaniciAdi, sifre);
        onLoginSuccess(data); 
    } catch (error) {
        console.error('Login hatası:', error);
        // Hata yönetimi aynı kalabilir. error.response.data.hata ile
        // backend'den gelen mesajı göstermek daha iyi olabilir.
        const hataMesaji = error.response?.data?.hata || 'Giriş yapılamadı. Sunucuya bağlanılamıyor.';
        setHata(hataMesaji);
    }
    };
    
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8f8f8' }}>
            <form onSubmit={handleLogin} style={{ padding: '30px', background: 'white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '300px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Sipariş Yönetim Paneli</h2>
                {hata && <p style={{ color: 'red', textAlign: 'center' }}>{hata}</p>}
                <div style={{ marginBottom: '20px' }}>
                    <label>Kullanıcı Adı:</label>
                    <input type="text" value={kullaniciAdi} onChange={e => setKullaniciAdi(e.target.value)} required style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', fontfamily: 'poppins' }} />
                </div>
                <div style={{ marginBottom: '30px' }}>
                    <label>Şifre:</label>
                    <input type="password" value={sifre} onChange={e => setSifre(e.target.value)} required style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', fontfamily: 'poppins' }} />
                </div>
                <button type="submit" style={{ width: '100%', padding: '12px', background:'linear-gradient(90deg, #3884C2 0%, #255380 100%)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', fontfamily: 'poppins'  }}>Giriş Yap</button>
            </form>
        </div>
    );
}

export default Login;